import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { CuttingList } from '../TitleList';
import styled, { cutDates, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import Divider from '@mui/material/Divider';
import { fetchMemoNo } from '../../Store/PHPSlice/Cutting/SOMcutting';
import { selectCloths, selectEmployees, selectItemAvg, selectItems, selectJobRate, selectMemoNo, selectSOlistReg } from '../Selectors/Master/ItemSelectors';
import { fetchEmployeeData } from '../../Store/PHPSlice/Employee';
import { fetchSORegister } from '../../Store/PHPSlice/Sale/SaleOrder';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { fetchItemAvgData } from '../../Store/PHPSlice/ItemAvg';
import { fetchJobRateData } from '../../Store/PHPSlice/JobRate';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';


const CutSOwise = () => {

    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        memoNo: '',
        master: '',
        sono: '',
        item: '',
        size: '',
        panna: '',
        cloth: '',
        mstkmtr: '',
        mreqmtr: '',
        mgivenmtr: '',
        mtch1: '',
        m1stkmtr: '',
        m1reqmtr: '',
        m1givenmtr: '',
        mtch2: '',
        m2stkmtr: '',
        m2reqmtr: '',
        m2givenmtr: '',
        mtch3: '',
        m3stkmtr: '',
        m3reqmtr: '',
        m3givenmtr: '',
        totqty: '',
        party: '',
        logo: '',
        schl: '',
        userId: '1'
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        master: fetchEmployeeData,
        sono: fetchSORegister,
        item: fetchItemData
        // Add more mappings if needed
    };
    const [masterlist, setMasterlist] = useState([]);
    const [clothdata, setClothdata] = useState([]);
    const [m1clothdata, setM1Clothdata] = useState([]);
    const [m2clothdata, setM2Clothdata] = useState([]);
    const [m3clothdata, setM3Clothdata] = useState([]);
    const [items, setItems] = useState({});
    const dispatch = useDispatch();
    const memo = useSelector(selectMemoNo);
    const emplist = useSelector(selectEmployees);
    const solist = useSelector(selectSOlistReg);
    const itemlist = useSelector(selectItems);
    const itemAvglist = useSelector(selectItemAvg);
    const jobratelist = useSelector(selectJobRate);
    const clothlist = useSelector(selectCloths)
    useEffect(() => {
        dispatch(fetchMemoNo());
        dispatch(fetchSORegister());
        dispatch(fetchItemData());
        dispatch(fetchItemAvgData());
        dispatch(fetchJobRateData());
        dispatch(fetchClothData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);


    useEffect(() => {
        if (memo.data) {
            setFormData(prev => ({
                ...prev,
                memoNo: memo.data.memo
            }));
        }
    }, [memo]);

    useEffect(() => {
        if (emplist.data.length > 0) {
            const data = getMasterlist(emplist.data);
            setMasterlist(data);
        }
    }, [emplist]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    function getMasterlist(emp) {
        const filterRecords = emp.filter((val) => val.departNm === 'CUTTING');
        return filterRecords;
    }


    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const isEmpty = Object.keys(items).length === 0;

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        if (dropdownType === 'sono' && value) {
            const selectitems = solist.data.length > 0 ? solist.data.find((val) => val.ID === value) : '';
            if (selectitems) {
                var itemId = selectitems.itemId;
            }
            const findItem = itemlist.data.length > 0 ? itemlist.data.find((val) => val.ID === itemId) : '';
            setItems(findItem);
        }
        switch (dropdownType) {
            case 'item':
                if (value) {
                    const selectJobRate = jobratelist.data.find(val => val.itemId === value);
                    const selectedSize = itemlist.data.find(val => val.ID === value);

                    // Filter and process average values
                    const selectPanna = itemAvglist.data.filter(val => val.itemId === value);
                    const selectAvg = selectPanna.filter(val => val.avg !== '0');
                    const selectm1Avg = selectPanna.filter(val => val.avg1 !== '0');
                    const selectm2Avg = selectPanna.filter(val => val.avg2 !== '0');
                    const selectm3Avg = selectPanna.filter(val => val.avg3 !== '0');

                    // Determine unique sizes
                    const uniquePannasizes = [...new Set(selectAvg.map(val => val.panna_size))];
                    const uniqueM1Pannasizes = [...new Set(selectm1Avg.map(val => val.panna_size))];
                    const uniqueM2Pannasizes = [...new Set(selectm2Avg.map(val => val.panna_size))];
                    const uniqueM3Pannasizes = [...new Set(selectm3Avg.map(val => val.panna_size))];

                    // Filter cloth data based on sizes
                    const filterCloth = clothlist.data.filter(val => uniquePannasizes.includes(val.panna_size));
                    const filterM1Cloth = clothlist.data.filter(val => uniqueM1Pannasizes.includes(val.panna_size));
                    const filterM2Cloth = clothlist.data.filter(val => uniqueM2Pannasizes.includes(val.panna_size));
                    const filterM3Cloth = clothlist.data.filter(val => uniqueM3Pannasizes.includes(val.panna_size));

                    // Update cloth data
                    setClothdata(filterCloth);
                    setM1Clothdata(filterM1Cloth);
                    setM2Clothdata(filterM2Cloth);
                    setM3Clothdata(filterM3Cloth);

                }
                break;

            default:
                break;
        }

    };

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        // let finalObject = convertIntoOneObject(tableRows, formData);

        // dispatch(createPOEntry(finalObject))
        //     .unwrap()
        //     .then((result) => {
        //         // Handle success
        //         console.log('POST request successful!', result);
        //         toast.success("Purchase Order Added");
        //         window.location.reload();
        //         // You may want to update your component state or perform any other action
        //     })
        //     .catch((error) => {
        //         // Handle error
        //         console.error('Error while making POST request:', error);
        //         // You may want to display an error message to the user or perform any other action
        //     });

    };

    return (
        <>
            <Titlebar data={CuttingList} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Cutting (Sale Order Wise) Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Memo No', name: 'memoNo', type: 'readOnly' }

                                ].map((field, index) => (
                                    <Grid item xs={12} md={4} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '28%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={0.5}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="master">Master:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="master"
                                                    id="master"
                                                    name="master"
                                                    value={formData.master}
                                                    onOpen={() => handleDropdownOpen('master')}
                                                    onClose={() => handleDropdownClose('master')}
                                                    onChange={(e) => handleDropdownChange(e, 'master')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {masterlist.length > 0 ? masterlist.map((item, index) => (
                                                        <MenuItem key={index} value={item.ID}>{item.empNm}</MenuItem>
                                                    )) : []}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ mt: 2, mb: 2 }}>
                                    <Divider />
                                </Grid>

                                <Grid item xs={12} md={5}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="sono">Sale Order No:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="sono"
                                                    name="sono"
                                                    options={solist.data}
                                                    getOptionLabel={(option) => option.sono || ''}
                                                    value={solist.data.find(item => item.ID === formData.sono) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'sono', value: newValue ? newValue.ID : '' } }, 'sono')}
                                                    onOpen={() => handleDropdownOpen('sono')}
                                                    onClose={() => handleDropdownClose('sono')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            // label="Select an option"
                                                            variant="outlined"
                                                            sx={{
                                                                ...cutDates,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>



                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="item">Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="item"
                                                    id="item"
                                                    name="item"

                                                    value={formData.item}
                                                    onChange={(e) => handleDropdownChange(e, 'item')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {isEmpty ? [] :
                                                        <MenuItem value={items.ID}>{items.itemNm}</MenuItem>
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* 
                                <Grid item xs={12} md={4}></Grid>
                                <Grid item xs={12} md={4}></Grid> */}


                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="cloth">Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="cloth"
                                                    id="cloth"
                                                    name="cloth"
                                                    value={formData.cloth}
                                                    onChange={(e) => handleDropdownChange(e, 'cloth')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {clothdata.length > 0 ? clothdata.map((item, index) => (
                                                        <MenuItem key={index} value={item.ID}>{item.clothNm} {item.model} {item.color} {item.shadeNo} {item.panna_size}</MenuItem>
                                                    )) : []}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {[
                                    { label: 'Stock Mtr', name: 'mstkmtr' },
                                    { label: 'Required Mtr', name: 'mreqmtr' },
                                    { label: 'Given Mtr', name: 'mgivenmtr' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={2.5} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '45%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.stockInput, readOnly: field.type === 'readOnly' }}
                                                        sx={stockNumber}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}



                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="mtch1">Match-1 :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="mtch1"
                                                    id="mtch1"
                                                    name="mtch1"
                                                    value={formData.mtch1}
                                                    onChange={(e) => handleDropdownChange(e, 'mtch1')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {m1clothdata.length > 0 ? m1clothdata.map((item, index) => (
                                                        <MenuItem key={index} value={item.ID}>{item.clothNm} {item.model} {item.color} {item.shadeNo} {item.panna_size}</MenuItem>
                                                    )) : []}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {[
                                    { label: 'Stock Mtr', name: 'm1stkmtr' },
                                    { label: 'Required Mtr', name: 'm1reqmtr' },
                                    { label: 'Given Mtr', name: 'm1givenmtr' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={2.5} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '45%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.stockInput, readOnly: field.type === 'readOnly' }}
                                                        sx={stockNumber}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="mtch2">Match-2 :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="mtch2"
                                                    id="mtch2"
                                                    name="mtch2"
                                                    value={formData.mtch2}
                                                    onChange={(e) => handleDropdownChange(e, 'mtch2')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {m2clothdata.length > 0 ? m2clothdata.map((item, index) => (
                                                        <MenuItem key={index} value={item.ID}>{item.clothNm} {item.model} {item.color} {item.shadeNo} {item.panna_size}</MenuItem>
                                                    )) : []}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {[
                                    { label: 'Stock Mtr', name: 'm2stkmtr' },
                                    { label: 'Required Mtr', name: 'm2reqmtr' },
                                    { label: 'Given Mtr', name: 'm2givenmtr' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={2.5} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '45%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.stockInput, readOnly: field.type === 'readOnly' }}
                                                        sx={stockNumber}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="mtch3">Match-3 :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="mtch3"
                                                    id="mtch3"
                                                    name="mtch3"
                                                    value={formData.mtch3}
                                                    onChange={(e) => handleDropdownChange(e, 'mtch3')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {m3clothdata.length > 0 ? m3clothdata.map((item, index) => (
                                                        <MenuItem key={index} value={item.ID}>{item.clothNm} {item.model} {item.color} {item.shadeNo} {item.panna_size}</MenuItem>
                                                    )) : []}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {[
                                    { label: 'Stock Mtr', name: 'm3stkmtr' },
                                    { label: 'Required Mtr', name: 'm3reqmtr' },
                                    { label: 'Given Mtr', name: 'm3givenmtr' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={2.5} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '45%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.stockInput, readOnly: field.type === 'readOnly' }}
                                                        sx={stockNumber}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} md={12} sx={{ mt: 2, mb: 2 }}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={10} md={11}>
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #ccc', fontSize: '15px' }} align='center'>Size</TableCell>
                                                    {isEmpty ? '' :
                                                        items.size.split(',').map((val, index) => (
                                                            <TableCell key={index} sx={{ p: 1, border: '1px solid #ccc' }} align='center'>{val}</TableCell>
                                                        ))
                                                    }
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #ccc', fontSize: '15px' }} align='center'>Quantity</TableCell>

                                                    {isEmpty ? '' :
                                                        items.size.split(',').map((item, index) => (
                                                            <TableCell align='center' sx={{ p: 1, border: '1px solid #ccc' }} key={index}>
                                                                <input
                                                                    type="text"
                                                                    // value={formData.qty[index] || '0'}
                                                                    // onChange={(e) => handleQtyChange(index, e.target.value)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                        ))}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                {/* {[
                                    { label: 'Total Qty', name: 'totqty', type: 'readOnly' },
                                    { label: 'Party', name: 'party', type: 'readOnly' },
                                    { label: 'Logo', name: 'logo', type: 'readOnly' },
                                    { label: 'School', name: 'schl', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={inputStyles}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))} */}



                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>


                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default CutSOwise;
